import React from 'react';
import { TesterForm } from '@features/tester/TesterForm';

export const TesterPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <TesterForm />
    </div>
  );
}; 